import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=15510af0&scoped=true&"
import script from "./Params.vue?vue&type=script&lang=js&"
export * from "./Params.vue?vue&type=script&lang=js&"
import style0 from "./Params.vue?vue&type=style&index=0&id=15510af0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15510af0",
  null
  
)

export default component.exports